export class OtpVerifyReq
{
    public RegNo:number;
    public OTP:string;
    
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/OtpVerifyReq.ts